import React from "react";
import '../assets/styles/Footer.scss';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CopyrightIcon from '@mui/icons-material/Copyright';

function Footer({parentToChild}: {parentToChild: any}) {

  const { mode } = parentToChild;

  return (
    <div className="footer">
      <span className='footer-icon'>{mode === 'dark' ? <span className='shine'><AutoAwesomeIcon/></span> : <span className='ai-driven'><AutoAwesomeIcon/></span> } AI-driven metrics</span>
      <p><CopyrightIcon/>2024 All rights reserved.</p>
    </div>
  );
}

export default Footer;